import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import SupportTicketsScreen from '../../components/SupportTickets/SupportTicketsScreen';
import SupportTicketPanel from '../../components/SupportTickets/SupportTicketPanel';
import { getPracticeAdminHomePath, isPracticeAdmin } from '../../utils/roleUtils';

const SupportTicketsPage = () => {
  const { user } = useSelector((state) => state.auth);
  const { updateBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();
  const [supportPanelOpen, setSupportPanelOpen] = useState(false);
  const [ticketsRefreshKey, setTicketsRefreshKey] = useState(0);

  const isSuperAdmin = Number(user?.role_id) === 1;
  const pageTitle = isSuperAdmin ? 'Support Ticket Admin' : 'My Support Tickets';

  useEffect(() => {
    const homePath = isPracticeAdmin(user) ? getPracticeAdminHomePath(user) : '/dashboard';
    updateBreadcrumbs([
      { label: 'Dashboard', path: homePath },
      { label: pageTitle, path: '/support-tickets', active: true },
    ]);
    return () => clearBreadcrumbs();
  }, [clearBreadcrumbs, pageTitle, updateBreadcrumbs, user]);

  const handleTicketSubmitted = () => {
    setSupportPanelOpen(false);
    setTicketsRefreshKey((value) => value + 1);
  };

  return (
    <>
      <SupportTicketsScreen
        key={ticketsRefreshKey}
        user={user}
        onOpenSubmitPanel={isSuperAdmin ? undefined : () => setSupportPanelOpen(true)}
      />
      {!isSuperAdmin && (
        <SupportTicketPanel
          open={supportPanelOpen}
          onClose={() => setSupportPanelOpen(false)}
          onSubmitted={handleTicketSubmitted}
        />
      )}
    </>
  );
};

export default SupportTicketsPage;
